/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// 在庫数超過チェック
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[name="add"], .product-form__submit');
    if (!btn) return;

    const form = btn.closest('form');
    if (!form) return;

    const variantId = form.querySelector('[name="id"]')?.value;
    const qtyInput = form.querySelector('[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value) : 1;

    if (!variantId) return;

    // 既存エラーを削除
    const existingMsg = document.querySelector('.custom-stock-error');
    if (existingMsg) existingMsg.remove();

    fetch(`/variants/${variantId}.js`)
      .then(r => r.json())
      .then(variant => {
        if (
          variant.inventory_management === 'shopify' &&
          variant.inventory_policy !== 'continue' &&
          variant.inventory_quantity < qty
        ) {
          // カート追加をキャンセル（Ajax送信を止める）
          btn.disabled = true;
          setTimeout(() => { btn.disabled = false; }, 100);

          // エラーメッセージをボタンの直後に挿入
          const msg = document.createElement('p');
          msg.className = 'custom-stock-error';
          msg.style.cssText = 'color: red; margin-top: 8px; font-size: 14px;';
          msg.textContent = `Requested quantity exceeds our current stock level.We only have ${variant.inventory_quantity} left in stock.`;
          btn.insertAdjacentElement('afterend', msg);
        }
      });
  });
});


// カートボタンの価格をバリアント変更時に更新
document.addEventListener('variant:changed', function(event) {
  const variant = event.detail.variant;
  const priceEl = document.querySelector('.buy-button__price');
  if (priceEl && variant) {
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    priceEl.innerHTML = '&nbsp;–&nbsp;' + formatter.format(variant.price / 100);
  }
});




